<template>
    <div class="main-container">
        <!-- Navbar section -->
		<HeaderSingle />

        <div class="section-space-header bg-grey" id="pricing">
            <div class="pricing-table-title-area position-relative ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12  wow move-up">
                            <div class="section-title-wrapper text-center section-space--mb_60">
                                <h2 class="section-title font-weight--light mb-15">Frequently Asked Questions</h2>
                                <span class="section-text wow move-up">It’s our pleasure to answer any questions you have</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- accordion section -->
        <div class="software-accordion-wrapper section-space--pt_120 section-space--pb_60 gray-gradient" id="faq">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faq-wrapper">
                            <!-- accordion component -->
                            <FaqContent />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faq-wrapper soft-accordion-two">
                            <!-- accordion component -->
                            <FaqContent />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer section -->
        <FooterMain />
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css'
    import 'swiper/dist/css/swiper.css'
    import '@/assets/static-style/style.scss';
    import 'slick-carousel/slick/slick.css'

    import HeaderSingle from './components/sections/HeaderSingle.vue'
    import FaqContent from './components/sections/FaQContent.vue'
    import FooterMain from './components/FooterMain.vue'

    export default {
        name: 'app',
        components: {
            HeaderSingle,
            FaqContent,
            FooterMain
        }
    }
</script>




<style lang="scss">
    @import '@/assets/static-style/_variabls.scss';
    @import '@/assets/scss/page-section/_payment.scss';
</style>

<style>
    .section-space-header {
        padding-top: 175px;
    }
    @media only screen and (max-width: 1199px) {
        .section-space-header {
            padding-top: 120px;
        }
    }
    @media only screen and (max-width: 767px) {
        .section-space-header {
            padding-top: 100px;
        }
    }
</style>